import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, finalize } from 'rxjs';

import { sanitizeUrl } from '../helpers/url.helper';

import { PreloadType, PreloaderService } from './preloader.service';

@Injectable()
export class PreloaderInterceptor implements HttpInterceptor {
  activeRequests = 0;

  constructor(private readonly preloaderService: PreloaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestName = (request.body && request.body.operationName) || sanitizeUrl(request.url);

    if (this.preloaderService.shouldTrackRequest(requestName)) {
      if (this.activeRequests === 0) {
        this.preloaderService.startLoading(PreloadType.REQUEST);
      }

      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.preloaderService.stopLoading(PreloadType.REQUEST);
          }
        })
      );
    } else {
      return next.handle(request);
    }
  }
}
